import { ReactNode } from "react";
import { AlertProvider } from "./alertContext";
import { AuthProvider } from "./authContext";
import { DetailBarangModalProvider } from "./detailBarangModalContext";
import { EditKategoriModalProvider } from "./editKategoriModalContext";
import { HapusKategoriModalProvider } from "./hapusKategoriModalContext";
import { HapusMultipleStokModalProvider } from "./hapusMultipleStokModalContext";
import { HapusStokModalProvider } from "./hapusStokModalContext";
import { HapusUkmModalProvider } from "./hapusUkmModalContext";
import { ImportModalProvider } from "./importModalContext";
import { KatalogModalProvider } from "./katalogModalContext";
import { KategoriModalProvider } from "./kategoriModalContext";
import { LogoutModalProvider } from "./logoutModalContext";
import { MutasiStokModalProvider } from "./mutasiStokModalContext";
import { PrintBarcodeModalProvider } from "./printBarcodeModal";
import { StokModalProvider } from "./stokModalContext";
import { TransaksiProvider } from "./transaksiContext";
import { UkmModalProvider } from "./ukmModalContext";

interface IindexProps {
    children: ReactNode;
}

const AppProvider = ({ children }: IindexProps) => {
    return (
        <AuthProvider>
            <AlertProvider>
                <LogoutModalProvider>
                    <StokModalProvider>
                        <HapusStokModalProvider>
                            <HapusMultipleStokModalProvider>
                                <KategoriModalProvider>
                                    <HapusKategoriModalProvider>
                                        <EditKategoriModalProvider>
                                            <KatalogModalProvider>
                                                <ImportModalProvider>
                                                    <MutasiStokModalProvider>
                                                        <DetailBarangModalProvider>
                                                            <UkmModalProvider>
                                                                <HapusUkmModalProvider>
                                                                    <PrintBarcodeModalProvider>
                                                                        <TransaksiProvider>
                                                                            {
                                                                                children
                                                                            }
                                                                        </TransaksiProvider>
                                                                    </PrintBarcodeModalProvider>
                                                                </HapusUkmModalProvider>
                                                            </UkmModalProvider>
                                                        </DetailBarangModalProvider>
                                                    </MutasiStokModalProvider>
                                                </ImportModalProvider>
                                            </KatalogModalProvider>
                                        </EditKategoriModalProvider>
                                    </HapusKategoriModalProvider>
                                </KategoriModalProvider>
                            </HapusMultipleStokModalProvider>
                        </HapusStokModalProvider>
                    </StokModalProvider>
                </LogoutModalProvider>
            </AlertProvider>
        </AuthProvider>
    );
};

export default AppProvider;
